import SearchToolbar from './SearchToolbar';

export default SearchToolbar;
